var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("客服客户导入")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "nav" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "未分配客户", name: "2" } }),
              _c("el-tab-pane", { attrs: { label: "分配失败", name: "3" } }),
              _c("el-tab-pane", { attrs: { label: "分配成功", name: "1" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.show3,
                expression: "!show3",
              },
            ],
            staticClass: "inquiry",
          },
          [
            _c("div", { staticClass: "header" }, [
              _c("span", [_vm._v("查询数据")]),
              _c(
                "p",
                {
                  on: {
                    click: function ($event) {
                      _vm.show3 = true
                    },
                  },
                },
                [_vm._v("收起")]
              ),
            ]),
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  inline: true,
                  model: _vm.queryForm,
                  "label-width": "",
                  size: "mini",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "订单信息" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入客户手机号码/姓名" },
                      model: {
                        value: _vm.queryForm.info,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "info", $$v)
                        },
                        expression: "queryForm.info",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "平台名称" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "选择分配状态",
                          clearable: "",
                          "default-first-option": "",
                          filterable: "",
                        },
                        model: {
                          value: _vm.queryForm.sourceFrom,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "sourceFrom", $$v)
                          },
                          expression: "queryForm.sourceFrom",
                        },
                      },
                      _vm._l(_vm.channel, function (items) {
                        return items.dictId != "comm"
                          ? _c("el-option", {
                              key: items.dictId,
                              attrs: {
                                label: items.dictName,
                                value: items.dictId,
                              },
                            })
                          : _vm._e()
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "selectDate" }, [
                  _c("span", [_vm._v("资源时间")]),
                  _c(
                    "div",
                    { staticClass: "picker" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy- MM- dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { input: _vm.immediUpdate },
                        model: {
                          value: _vm.date,
                          callback: function ($$v) {
                            _vm.date = $$v
                          },
                          expression: "date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName == "1",
                        expression: "activeName == '1'",
                      },
                    ],
                    staticClass: "selectDate",
                  },
                  [
                    _c("span", [_vm._v("分配时间")]),
                    _c(
                      "div",
                      { staticClass: "picker" },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            "unlink-panels": "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            format: "yyyy- MM- dd",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.assigedate,
                            callback: function ($$v) {
                              _vm.assigedate = $$v
                            },
                            expression: "assigedate",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.searchEvent()
                          },
                        },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { plain: "", loading: _vm.loading },
                        on: { click: _vm.reset },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeName == "2",
                      expression: "activeName == '2'",
                    },
                  ],
                  attrs: { placeholder: "导入客户", clearable: "" },
                  on: { change: _vm.modeGuide },
                  model: {
                    value: _vm.guideId,
                    callback: function ($$v) {
                      _vm.guideId = $$v
                    },
                    expression: "guideId",
                  },
                },
                _vm._l(_vm.channel, function (item) {
                  return _c("el-option", {
                    key: item.dictId,
                    attrs: { label: item.dictName, value: item.dictId },
                  })
                }),
                1
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeName == "2",
                      expression: "activeName == '2'",
                    },
                  ],
                  staticClass: "onekey",
                  on: { click: _vm.trueDistribution },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/icon_liebiao.png"),
                      alt: "",
                    },
                  }),
                  _c("span", [_vm._v("一键分配")]),
                ]
              ),
              _c(
                "p",
                { staticStyle: { "margin-left": "15px" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "upload-demo",
                      attrs: {
                        multiple: false,
                        action: "#",
                        "show-file-list": false,
                        "http-request": _vm.automatic,
                        "auto-upload": true,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "mini",
                            type: "primary",
                          },
                          slot: "trigger",
                        },
                        [_vm._v("自动分配")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "p",
                { staticStyle: { "margin-left": "15px" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "upload-demo",
                      attrs: {
                        multiple: false,
                        action: "#",
                        "show-file-list": false,
                        "http-request": _vm.wyImport,
                        "auto-upload": true,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "mini",
                            type: "primary",
                          },
                          slot: "trigger",
                        },
                        [_vm._v("单号导出")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "p",
                { staticStyle: { "margin-left": "15px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "trigger", size: "mini", type: "danger" },
                      on: { click: _vm.deleteIds },
                      slot: "trigger",
                    },
                    [_vm._v("批量删除")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show3,
                  expression: "show3",
                },
              ],
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function ($event) {
                  _vm.show3 = false
                },
              },
            },
            [_vm._v("搜索展开")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "vxe-table",
            {
              ref: "xGrid",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData.list, align: "center" },
              on: {
                "checkbox-all": _vm.selectAllEvent,
                "checkbox-change": _vm.selectChangeEvent,
              },
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "checkbox", width: "40" },
              }),
              _c("vxe-table-column", {
                attrs: { type: "seq", title: "序号", "min-width": "50" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "orderNo",
                  title: "订单编号",
                  "show-overflow-tooltip": true,
                  "min-width": "120",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "客户信息",
                  "min-width": "150",
                  "show-overflow": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.customerName))]),
                        scope.row.assignErrorType == "1" &&
                        _vm.activeName == "3"
                          ? _c("span", { staticClass: "exisit" }, [
                              _vm._v("已存在"),
                            ])
                          : _vm._e(),
                        scope.row.assignErrorType == "2" &&
                        _vm.activeName == "3"
                          ? _c("span", { staticClass: "exisit" }, [
                              _vm._v("手机号相同"),
                            ])
                          : _vm._e(),
                        scope.row.assignErrorType == "3" &&
                        _vm.activeName == "3"
                          ? _c("span", { staticClass: "exisit" }, [
                              _vm._v("分配人为空"),
                            ])
                          : _vm._e(),
                        _c(
                          "p",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                _vm.$copyText(scope.row.customerPhone).then(
                                  function (e) {
                                    _vm.$message({
                                      type: "success",
                                      message: "成功复制手机号",
                                    })
                                  },
                                  function (e) {
                                    _vm.$message({
                                      type: "warning",
                                      message: "复制失败",
                                    })
                                  }
                                )
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.customerPhone) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "选购商品",
                  "show-overflow": "",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.prodName) +
                              " " +
                              _vm._s(scope.row.prodItem)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { scope: "scope", title: "渠道", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.activeName != "1"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "选择渠道",
                                      filterable: "",
                                      "default-first-option": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeContent(scope.row)
                                      },
                                    },
                                    model: {
                                      value: scope.row.channelId,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "channelId", $$v)
                                      },
                                      expression: "scope.row.channelId",
                                    },
                                  },
                                  _vm._l(_vm.line, function (items) {
                                    return _c("el-option", {
                                      key: items.id,
                                      attrs: {
                                        label: items.name,
                                        value: items.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("p", [_vm._v(_vm._s(scope.row.channelName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "分配客服", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.activeName != "1"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "选择客服",
                                      filterable: "",
                                      "default-first-option": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeContent(scope.row)
                                      },
                                    },
                                    model: {
                                      value: scope.row.assignorIdView,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "assignorIdView",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.assignorIdView",
                                    },
                                  },
                                  _vm._l(_vm.customer, function (items) {
                                    return _c("el-option", {
                                      key: items.id,
                                      attrs: {
                                        label: items.reallyName,
                                        value: items.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("p", [_vm._v(_vm._s(scope.row.assignorName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "资源时间",
                  "show-overflow": "",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.is_null(scope.row.orderTime)
                          ? _c("p", [
                              _vm._v(" " + _vm._s(scope.row.orderTime) + " "),
                            ])
                          : _c("p", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "sourceFromName",
                  title: "导入平台",
                  "min-width": "100",
                },
              }),
              _vm.activeName == "1"
                ? _c("vxe-table-column", {
                    attrs: {
                      title: "分配时间",
                      "show-overflow": "",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.is_null(scope.row.assignTime)
                                ? _c("p", [
                                    _vm._v(
                                      " " + _vm._s(scope.row.assignTime) + " "
                                    ),
                                  ])
                                : _c("p", [_vm._v("--")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4004280879
                    ),
                  })
                : _vm._e(),
              _c("vxe-table-column", {
                attrs: { title: "操作", "min-width": "240" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "p",
                          { staticClass: "operation" },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-color": "#409EFF",
                                "inactive-color": "#eee",
                              },
                              model: {
                                value: scope.row.cutOff,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "cutOff", $$v)
                                },
                                expression: "scope.row.cutOff",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.parArray.indexOf("qdfp") != -1 &&
                        _vm.activeName != "1"
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.distribution(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 分配 ")]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("qdsee") != -1
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.tosee(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 查看 ")]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("qdsee") != -1
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.copyInfo(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 复制 ")]
                            )
                          : _vm._e(),
                        _vm.activeName == "1"
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.toDetailCustomer(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 客户详情 ")]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("delectCode") != -1 &&
                        _vm.activeName != "1"
                          ? _c(
                              "p",
                              {
                                staticClass: "operation delect",
                                on: {
                                  click: function ($event) {
                                    return _vm.delectEvent(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 删除 ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticStyle: { height: "40px" } }),
      _vm.tableData.totalNum >= 1
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage1,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.tableData.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.leadingInLive,
            "append-to-body": true,
            title: "订单导入",
          },
          on: {
            "update:visible": function ($event) {
              _vm.leadingInLive = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "popIn" },
            [
              _c(
                "el-upload",
                {
                  ref: "tops",
                  staticClass: "upload-demo",
                  attrs: {
                    accept: ".doc,.docx,.xls,.xlsx,.csv",
                    drag: "",
                    action: "#",
                    multiple: false,
                    "http-request": _vm.orderImportLive,
                    limit: 1,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.keyvalue == "comm"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.templateMode()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "OPPO"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.opopImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "BaiDu"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.baiduImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "RestAssured"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.safeImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "Phoenix"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.phoneixImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "GuangDianTong"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.broadpointImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "uc"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.uCImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "head"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.headlinesImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "aqy"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.headlinesAiqiyi()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "ks"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.kwaiFu()
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.leadingInLive = false
                      _vm.guideId = ""
                      _vm.$refs.tops.clearFiles()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }